// 表单逻辑
import { evalExpression } from '@/utils/expression'

// 逻辑触发规则保存 key为条件字段ID value为触发规则表达式 监听key的字段值发生变化时 进行逻辑判断 成立则吧对应的字段显示
let logicTriggerRules = {}

// 默认要满足条件才显示的字段
let hiddenFormItemIds = new Map()

// 条件表单项的逻辑组对应格式为 { id: [codinitionGroup,codinitionGroup] }
let onlyTriggerRules = {}

/**
 * 解析表单逻辑
 * @param data
 */
export function parserFormLogic(data) {
  logicTriggerRules = {}
  onlyTriggerRules = {}
  let logicItemList = data.formLogic ? data.formLogic.scheme || [] : []
  logicItemList.forEach((item) => {
    logicShowTriggerHandle(item)
  })
  return { logicTriggerRules, hiddenFormItemIds }
}

/**
 * 获取满足条件的表单数据
 * logicTriggerRules 对象 {}
 * {
 *   "radio1677384789963": [
 *     {
 *         "triggerFormItemId": "goods_select1677384984064", // 触发显示的字段ID
 *         "logicExpression": "radio1677384789963 eq 1  " // 逻辑表达式
 *     },
 *     {
 *         "triggerFormItemId": "goods_select1677384986954",
 *         "logicExpression": "radio1677384789963 eq 2  "
 *     }
 * ]
 * }
 */
export function getFormLogicData(formData, logicTriggerRules) {
  Object.keys(logicTriggerRules).forEach((key) => {
    const rules = logicTriggerRules[key]
    if (rules && Array.isArray(rules)) {
      for (let rule of rules) {
        const flag = evalExpression(formData, rule.logicExpression)
        if (!flag) {
          delete formData[rule.triggerFormItemId]
        }
      }
    }
  })
  return formData
}

/**
 * 处理逻辑显示数据
 */
function logicShowTriggerHandle(logicItem) {
  if (!logicItem) {
    return
  }
  // 建立触发关系 该字段值发生变化时 哪些问题需要进行逻辑判断 确定是否显示
  logicItem.triggerList?.forEach((trigger) => {
    hiddenFormItemIds.set(trigger.formItemId, trigger)
    // 因为同一道题目可能会被多个逻辑组控制，所以在这里先汇总
    let rules = onlyTriggerRules[trigger.formItemId] || []
    rules.push(logicItem.conditionGroup)
    onlyTriggerRules[trigger.formItemId] = rules

    logicItem.conditionGroup.forEach((item) => {
      item.conditionList.forEach((cItem) => {
        if (Object.keys(item).length === 0) {
          return
        }
        // 这里的key是逻辑的条件 比如逻辑为  选中单选题1的选项，则显示 多选题；那么这里的key就是单选题1的formItemId
        // 因为表单数据变更时，要处理所有和这个表单项相关的逻辑数据，所以在这里做一个组装
        const rulesKey = cItem.type === '_TITLE' ? cItem.formItemId : cItem.parameter
        let defaultRule = logicTriggerRules[rulesKey] || []
        defaultRule.push({
          // 被触发显示的字段的ID
          triggerFormItemId: trigger.formItemId,
          // 被控制题目的逻辑数据
          logicExpression: onlyTriggerRules[trigger.formItemId]
        })
        logicTriggerRules[rulesKey] = defaultRule
      })
    })
  })
}
